<template>
  <FormContainer>
    <template #title>Rémunération</template>
    <template #content>
      <div
        class="form__bloc"
        v-if="model?.remuneration?.ventilations?.length ?? 0 > 0"
      >
        <template
          v-for="(item, index) in model?.remuneration?.ventilations"
          :key="index"
        >
          <BasicText
            weight="bold"
            size="body-m"
            v-if="index % 2 === 0"
            class="col-3 col-md-4 col-sm-36"
            style="margin: 10px 4px"
          >
            {{ AnneeFormationLibelle[item.anneeFormation as AnneeFormation] ?? 'Année inconnue' }}
          </BasicText>
          <div
            v-else
            class="col-1 col-md-4 col-sm-36"
            style="min-height: 20px"
          ></div>

          <WrapperInputDate
            id="field_112"
            :model-value="item.dateRange?.start"
            @update:model-value="(value: any) => updateRemuneration('dateRange.start', index, value)"
            label="Du"
            class="col-4 col-md-8 col-sm-36"
            :class="{ impaire: index % 2 !== 0 }"
            :required="
              meta.remuneration?.ventilations?.at(index)?.dateRange?.start?.$status === PropertyStatus.Required
            "
            :alertLabel="meta.remuneration?.ventilations?.at(index)?.dateRange?.start?.$messageErreurDirty!"
            readonly
            disabled
          />
          <WrapperInputDate
            id="field_112"
            :model-value="item.dateRange?.end"
            @update:model-value="(value: any) => updateRemuneration('dateRange.end', index, value)"
            :required="meta.remuneration?.ventilations?.at(index)?.dateRange?.end?.$status === PropertyStatus.Required"
            :alertLabel="meta.remuneration?.ventilations?.at(index)?.dateRange?.end?.$messageErreurDirty!"
            label="Au"
            class="col-4 col-md-8 col-sm-36"
            :class="{ impaire: index % 2 !== 0 }"
            readonly
            disabled
          />
          <WrapperInputNumber
            v-if="meta.remuneration?.ventilations?.at(index)?.pourcentage?.$status !== PropertyStatus.NotPresent"
            id="field_112"
            :model-value="item.pourcentage"
            @update:model-value="(value: any) => updateRemuneration('pourcentage', index, value)"
            :required="meta.remuneration?.ventilations?.at(index)?.pourcentage?.$status === PropertyStatus.Required"
            :alertLabel="meta.remuneration?.ventilations?.at(index)?.pourcentage?.$messageErreurDirty!"
            label="Pourcentage"
            placeholder="%"
            pourcentage
            :decimal="0"
            class="col-3 col-md-8 col-sm-36"
            :class="{ impaire: index % 2 !== 0 }"
            :readonly
            :disabled="meta.remuneration?.ventilations?.at(index)?.pourcentage?.$status === PropertyStatus.NotPresent"
            :maxlength="3"
            help="Pourcentage"
          />
          <WrapperInputNumber
            v-else
            id="field_112"
            label="Pourcentage"
            placeholder="%"
            pourcentage
            :decimal="0"
            class="col-3 col-md-8 col-sm-36"
            :class="{ impaire: index % 2 !== 0 }"
            disabled
            help="Pourcentage"
          />
          <WrapperDropdown
            v-if="meta.remuneration?.ventilations?.at(index)?.baseCalcul?.$status !== PropertyStatus.NotPresent"
            id="field_112"
            :model-value="item.baseCalcul"
            :items="lov.BaseCalculRemuneration"
            :required="meta.remuneration?.ventilations?.at(index)?.baseCalcul?.$status === PropertyStatus.Required"
            :alertLabel="meta.remuneration?.ventilations?.at(index)?.baseCalcul?.$messageErreurDirty!"
            key-id="code"
            key-label="intitule"
            @update:model-value="(value: any) => updateRemuneration('baseCalcul', index, value)"
            label="Type"
            class="col-5 col-md-8 col-sm-36"
            :class="[{ impaire: index % 2 !== 0 }, { impaireMobile: index % 2 !== 0 }]"
            :readonly
            :disabled="meta.remuneration?.ventilations?.at(index)?.baseCalcul?.$status === PropertyStatus.NotPresent"
          />
          <WrapperDropdown
            v-else
            id="field_112"
            key-id="code"
            key-label="intitule"
            label="Type"
            class="col-5 col-md-8 col-sm-36"
            :class="{ impaire: index % 2 !== 0 }"
            disabled
          />
        </template>
      </div>

      <div class="form__bloc">
        <WrapperInputNumber
          id="field_144"
          v-model="salaireBrutModel"
          label="Salaire brut à l’embauche"
          :required="meta.remuneration?.salaireBrutMensuelEmbauche?.$status === PropertyStatus.Required"
          :alertLabel="meta.remuneration?.salaireBrutMensuelEmbauche?.$messageErreurDirty!"
          class="col-8 col-md-18 col-sm-36"
          :placeholder="PLACEHOLDER_MONTANT"
          separateur
          :readonly
          :disabled="meta.remuneration?.salaireBrutMensuelEmbauche?.$status === PropertyStatus.NotPresent"
        />

        <WrapperInput
          id="field_145"
          v-model="caisseRetraiteModel"
          label="Caisse de retraite complémentaire"
          :required="meta.contrat?.caisseRetraitreComplementaire?.$status === PropertyStatus.Required"
          :alertLabel="meta.contrat?.caisseRetraitreComplementaire?.$messageErreurDirty!"
          class="col-16 col-md-18 col-sm-36"
          placeholder="Ex: AG2R, APICIL, ..."
          :readonly
          hint="100 caractères max"
          :maxlength="100"
          :disabled="meta.contrat?.caisseRetraitreComplementaire?.$status === PropertyStatus.NotPresent"
        />
      </div>
      <BasicText
        v-if="linkCalcultatriceDisplay"
        size="body-m"
        font-style="italic"
      >
        Il convient de l’appliquer une rémunération globale plus favorable si une disposition conventionnelle ou contractuelle existe.<br/>
        Merci de vous référer à ce
        <BasicLink
          label="lien"
          @link-click="redirectExterne('https://www.akto.fr/calcul-cout-contrat-apprentissage/')"
        />
        pour connaître le salaire applicable.
      </BasicText>
      <div class="form__bloc">
        <BasicText
          class="col-36"
          size="body-m"
          style="margin-bottom: -18px; margin-left: 4px"
        >
          Avantages en nature
        </BasicText>
        <WrapperInputNumber
          id="field_146"
          v-model="avantagesNourritureModel"
          hint="Nourriture"
          :required="meta.remuneration?.avantageNourriture?.$status === PropertyStatus.Required"
          :alertLabel="meta.remuneration?.avantageNourriture?.$messageErreurDirty!"
          class="col-12"
          placeholder="€/ repas"
          separateur
          :readonly
          :disabled="meta.remuneration?.avantageNourriture?.$status === PropertyStatus.NotPresent"
        />
        <WrapperInputNumber
          id="field_147"
          v-model="avantagesLogementModel"
          hint="Logement"
          :required="meta.remuneration?.avantageLogement?.$status === PropertyStatus.Required"
          :alertLabel="meta.remuneration?.avantageLogement?.$messageErreurDirty!"
          class="col-12"
          placeholder="€/ mois"
          separateur
          :readonly
          :disabled="meta.remuneration?.avantageLogement?.$status === PropertyStatus.NotPresent"
        />
        <div class="col-12 col-sm-36 checkbox--container">
          <BasicCheckbox
            id="field_148"
            v-model="avantagesAutresModel"
            label="Autre"
            :readonly
            :disabled="meta.remuneration?.avantageAutre?.$status === PropertyStatus.NotPresent"
          />
        </div>
      </div>
    </template>
  </FormContainer>
</template>

<script setup lang="ts">
  import type { VentilationRemunerationDTO } from '@/features/api/extranet/dto/Demande/CAPP'
import { useAppStateStore } from '@/features/application'
import { PropertyStatus } from '@/features/domaine/property-status/PropertyStatus'
import { isAdherentOuMandatGestion } from '@/features/domaine/regles-akto/shared/tools'
import { AnneeFormation, AnneeFormationLibelle } from '@/features/domaine/types/opco/Demande/CAPP'
import { useDemandeCAPPStore } from '@/features/interface/demande/capp/useDemandeCAPPStore'
import { FormContainer, PLACEHOLDER_MONTANT } from '@/features/interface/demande/shared'
import { redirectExterne } from '@/features/shared/tools/url'
import { storeToRefs } from 'pinia'
import { computed } from 'vue'

  const appState = useAppStateStore()
  const store = useDemandeCAPPStore()
  const { setupFieldWithKey, setupArrayUpdaterWithKey } = store
  const { meta, model, readonly, lov } = storeToRefs(store)

  const updateRemuneration = setupArrayUpdaterWithKey<VentilationRemunerationDTO>('remuneration.ventilations')
  const caisseRetraiteModel = setupFieldWithKey<string>('contrat.caisseRetraitreComplementaire', true)
  const salaireBrutModel = setupFieldWithKey<string>('remuneration.salaireBrutMensuelEmbauche', true)
  const avantagesNourritureModel = setupFieldWithKey<string>('remuneration.avantageNourriture', false)
  const avantagesLogementModel = setupFieldWithKey<string>('remuneration.avantageLogement', false)
  const avantagesAutresModel = setupFieldWithKey<boolean>('remuneration.avantageAutre', false)

  const linkCalcultatriceDisplay = computed(() => {
    return isAdherentOuMandatGestion(appState.contextCourant, model.value?.estSousMandatGestion ?? false)
  })
</script>

<style scoped lang="less">
  .section {
    display: flex;
  }

  @container (min-width: @breakpoint-mobile) and (max-width: @breakpoint-tablet) {
    .impaire {
      margin-bottom: 36px;
    }
  }

  @container (max-width: @breakpoint-mobile) {
    .impaireMobile {
      margin-bottom: 36px;
    }
  }

  .checkbox--container {
    height: 40px;
    color: @neutral-500;
    display: flex;
    flex-direction: column;
    justify-content: center;
  }
</style>

